var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionsEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 373,
    viewBox: "0 0 360 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7942 79.7253C21.082 78.296 23.5832 73.6509 22.1539 69.3631C20.7246 65.0753 16.0795 62.5741 11.4344 64.0034C7.1466 65.4326 4.64538 70.0778 6.07465 74.3656C7.50392 78.6534 12.149 81.1546 16.7942 79.7253Z",
    fill: "#E4DAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0174 52.5696C37.876 51.4976 39.6625 48.2818 38.5906 45.4233C37.5186 42.5647 34.3028 40.7781 31.4442 41.8501C28.5857 42.922 26.7991 46.1379 27.8711 48.9964C28.5857 51.855 31.8016 53.6415 35.0174 52.5696Z",
    fill: "#E4DAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M337.512 117.505C342.872 112.86 343.229 104.642 338.227 99.6391C333.582 94.6367 325.363 94.2794 320.361 98.9245C315.001 103.57 314.644 111.788 319.646 116.79C324.291 121.793 332.51 122.15 337.512 117.505Z",
    fill: "#E4DAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.805 142.543C358.949 140.399 359.307 137.183 357.163 135.039C355.019 132.895 351.803 132.538 349.659 134.682C347.515 136.825 347.158 140.041 349.302 142.185C351.088 144.686 354.661 144.686 356.805 142.543Z",
    fill: "#E4DAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.444 354.503C33.5879 352.359 33.9453 349.143 31.8014 346.999C29.6575 344.855 26.4416 344.498 24.2977 346.642C22.1538 348.785 21.7965 352.001 23.9404 354.145C26.0843 356.289 29.3001 356.646 31.444 354.503Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.51 372.011C258.34 372.011 333.019 297.689 333.019 206.216C332.662 114.385 258.34 40.0635 166.51 40.0635C74.3219 40.0635 0 114.385 0 205.859C0 297.689 74.3219 372.011 166.51 372.011Z",
    fill: "#F3F1FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M277.013 120.4V133.241H276.025H263.513L71.5615 132.583C67.9397 132.583 64.318 131.924 60.6963 130.936C60.367 130.936 60.0378 130.607 59.7085 130.607C55.099 128.961 51.1481 126.985 47.8556 123.693C45.2216 121.059 43.2461 117.108 43.2461 113.486C43.2461 106.572 48.8433 101.304 56.7453 98.0114C59.3793 96.6944 62.6718 96.0359 65.9643 95.7067C67.2812 95.7067 68.5982 95.3774 69.9152 95.3774H251.99C253.965 95.3774 255.611 95.7067 257.258 96.0359C258.575 96.3652 259.892 96.6944 261.209 97.3529C270.757 101.304 277.013 109.864 277.013 120.4Z",
    fill: "url(#paint0_linear_0_4737)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M276.025 133.241H263.513L71.5614 132.582C67.9396 132.582 64.3179 131.924 60.6962 130.936C60.3669 130.936 60.0377 130.607 59.7084 130.607C55.0989 128.961 51.148 126.985 47.8555 123.693C50.1602 121.388 53.1234 119.412 56.7452 118.095C59.3792 116.778 62.6717 116.12 65.9642 115.791C67.2811 115.461 68.5981 115.461 69.9151 115.461H251.99C253.965 115.461 255.611 115.791 257.258 116.12C258.575 116.449 259.892 116.778 261.209 117.437C268.452 120.4 273.72 126.327 276.025 133.241Z",
    fill: "#15112D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_4737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.389 153.325V314.986C300.389 326.181 291.5 335.07 280.305 335.07H86.3778C70.2446 335.07 57.7332 327.498 49.8312 321.242C46.2095 318.279 43.9047 313.669 43.9047 309.06C43.9047 306.755 43.9047 304.45 43.9047 302.146C43.9047 298.853 43.9047 294.902 43.9047 290.951C43.9047 272.513 43.9047 247.82 43.5755 222.797C43.5755 219.175 43.5755 215.553 43.5755 211.602C43.5755 198.432 43.5755 185.262 43.2462 172.751C43.2462 169.129 43.2462 165.507 43.2462 161.556C43.2462 136.863 42.917 118.425 42.917 114.145C42.917 121.388 49.8312 127.973 59.0502 130.607C59.3794 130.607 59.7087 130.936 60.0379 130.936C63.3304 131.924 67.2814 132.582 70.9031 132.582L262.855 133.57H276.684H279.976C291.5 133.241 300.389 142.131 300.389 153.325Z",
    fill: "url(#paint1_linear_0_4737)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M261.538 208.31C254.624 208.31 248.698 210.944 244.417 215.224C240.137 219.504 237.174 225.76 237.174 232.345C237.174 232.674 237.174 233.332 237.174 233.662C237.832 246.502 248.698 256.709 261.538 256.709H300.39V208.31H261.538Z",
    fill: "url(#paint2_linear_0_4737)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_4737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.389 199.091V205.017C300.06 205.017 299.731 205.017 299.072 205.017H259.563C252.648 205.017 246.722 207.651 242.442 211.932C238.491 215.882 235.527 221.809 235.198 228.065C235.198 228.394 235.198 229.052 235.198 229.382C235.198 242.881 246.063 253.746 259.563 253.746H299.072C301.048 253.746 302.694 253.088 303.353 252.1C303.682 251.771 304.011 251.112 304.011 250.783V202.054C304.011 200.408 302.365 199.42 300.389 199.091Z",
    fill: "url(#paint3_linear_0_4737)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M257.587 243.868C265.489 243.868 272.074 237.283 272.074 229.381C272.074 221.48 265.489 214.895 257.587 214.895C249.685 214.895 243.1 221.48 243.1 229.381C243.1 237.283 249.685 243.868 257.587 243.868Z",
    fill: "#7647EE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M131.218 242.521C136.658 242.521 141.261 237.918 141.261 232.477C141.261 227.037 136.658 222.434 131.218 222.434C125.778 222.434 121.175 227.037 121.175 232.477C121.175 237.918 125.778 242.521 131.218 242.521Z",
    fill: "#15112D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.216 242.521C213.656 242.521 218.259 237.918 218.259 232.477C218.259 227.037 213.656 222.434 208.216 222.434C202.776 222.434 198.173 227.037 198.173 232.477C198.173 238.336 202.776 242.521 208.216 242.521Z",
    fill: "#15112D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.825 199.25L108.732 211.179L111.715 216.702L133.807 204.774L130.825 199.25Z",
    fill: "#15112D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.851 199.091L203.869 204.615L225.964 216.542L228.946 211.018L206.851 199.091Z",
    fill: "#15112D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.717 265.955C176.188 265.955 181.434 262.02 181.434 257.167C181.434 252.313 176.188 248.379 169.717 248.379C163.246 248.379 158 252.313 158 257.167C158 262.02 163.246 265.955 169.717 265.955Z",
    fill: "#15112D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M342.183 13.5392C309.505 6.37284 274.533 7.51945 242.428 16.979C235.835 18.9856 228.669 21.5654 223.509 26.1519C215.483 32.7449 212.043 44.4976 214.623 54.5305C217.203 64.5633 225.802 72.8762 236.408 74.8828C243.001 76.6027 251.028 74.3095 255.041 68.8631C258.767 63.1301 257.907 54.5305 253.321 49.3707C248.734 43.6377 241.281 41.3445 234.402 41.6311C227.522 41.9178 220.642 44.4976 214.623 47.6508C195.13 58.257 179.364 76.8894 172.771 98.675C169.429 109.258 168.252 120.383 169.108 131.326",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M359.382 6.08607C359.095 10.3859 358.809 14.399 355.656 15.259C352.502 16.1189 351.069 13.2524 349.063 9.23925C347.056 5.51276 348.203 1.49963 351.642 0.639669C354.796 -0.220289 359.955 0.926322 359.382 6.08607Z",
    fill: "#FCDEB1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M355.943 26.7254C356.803 21.5657 357.663 18.6992 354.796 17.2659C351.643 15.8326 349.637 18.4125 346.197 21.8523C343.33 25.0055 345.05 29.592 347.917 31.0252C351.357 32.7451 355.083 31.0252 355.943 26.7254Z",
    fill: "#FCDEB1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M359.956 17.2657C359.669 19.2723 358.236 20.7056 356.229 20.9922C355.369 20.9922 354.509 20.9922 353.363 20.9922C349.349 20.4189 346.196 17.839 346.483 15.2592C346.77 12.6793 350.496 11.246 355.083 11.8193C355.942 11.8193 356.802 12.106 357.376 12.3926C359.096 12.9659 360.242 14.9725 359.956 17.2657C359.956 16.9791 359.956 17.2657 359.956 17.2657Z",
    fill: "#989FB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3926 60.4045C44.3926 55.5314 44.3926 50.6583 47.8324 49.225C51.5589 47.7918 53.5655 51.2316 56.432 56.1047C59.0119 60.4045 57.8652 64.9909 54.1388 66.4242C50.9856 67.8574 44.3926 66.9975 44.3926 60.4045Z",
    fill: "#A3DFBC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3987 36.3256C45.8254 42.3453 44.9654 45.7852 48.6919 47.2184C52.4184 48.6517 54.425 45.4985 58.1514 40.9121C61.018 36.8989 59.0114 31.7392 55.2849 30.3059C51.5584 28.8727 46.972 31.4525 46.3987 36.3256Z",
    fill: "#A3DFBC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2461 47.7916C43.2461 45.4984 44.966 43.7785 46.9726 43.4918C47.8325 43.2052 48.9791 43.2052 50.1258 43.4918C54.7122 43.7785 58.7253 46.3584 58.4387 49.2249C58.152 52.0914 54.4255 54.098 49.5525 53.5247C48.6925 53.5247 47.8325 53.238 46.9726 52.9514C44.6794 52.6647 43.2461 50.3715 43.2461 47.7916Z",
    fill: "#989FB0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7383 48.6514C92.8368 48.6514 148.447 66.1372 149.307 130.347",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_4737",
    x: 20.917,
    y: 103.145,
    width: 301.473,
    height: 264.926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_4737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_4737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_4737",
    x: 213.198,
    y: 188.091,
    width: 112.813,
    height: 98.6553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_4737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_4737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4737",
    x1: 160.148,
    y1: 96.6928,
    x2: 160.148,
    y2: 117.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4737",
    x1: 171.569,
    y1: 109.034,
    x2: 171.569,
    y2: 337.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_4737",
    x1: 268.787,
    y1: 209.991,
    x2: 268.787,
    y2: 237.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_4737",
    x1: 269.582,
    y1: 197.827,
    x2: 269.582,
    y2: 254.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsEmptyState);
export default __webpack_public_path__ + "static/media/transactions-empty-state.5d4f2522ce7fffc03d1df658e1c946f7.svg";
export { ForwardRef as ReactComponent };